import { render } from "./TableCheckbox.vue?vue&type=template&id=b5853fec&scoped=true&ts=true&lang=pug"
import script from "./TableCheckbox.vue?vue&type=script&lang=ts"
export * from "./TableCheckbox.vue?vue&type=script&lang=ts"

import "./TableCheckbox.vue?vue&type=style&index=0&id=b5853fec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5853fec"]])

export default __exports__